import cn from 'classnames';
import React from 'react';
import Icon, { IconType } from '../Icon';

interface SocialsProps {
  className?: string;
}

const Socials: React.FC<SocialsProps> = props => {
  const { className } = props;
  const icons = [
    {
      src: 'https://www.linkedin.com/company/perpetua-labs/',
      icon: IconType.linkedin,
    },
    {
      src: 'https://www.instagram.com/perpetua.io/',
      icon: IconType.instagram,
    },
    {
      src: 'https://www.youtube.com/channel/UCVPWE5c8kRN6QOcp8ntIbTw',
      icon: IconType.youtube,
    },
    {
      src: 'https://twitter.com/PerpetuaLabs',
      icon: IconType.twitter,
    },
    {
      src: 'https://www.facebook.com/perpetualabs/',
      icon: IconType.facebook,
    },
    {
      src: 'https://www.tiktok.com/@perpetua.io',
      icon: IconType.tiktok,
    },
  ];

  return (
    <div
      className={cn(
        'flex items-center space-x-6 mb-3 md:mr-12 text-gray-3-dark',
        className
      )}
    >
      {icons?.map((icon, i) => {
        return (
          <a
            key={i}
            className="flex items-center hover:text-indigo-2"
            target="_blank"
            rel="nofollow noreferrer"
            href={icon.src}
          >
            <Icon
              className="text-gray fill-current h-[15px]"
              iconType={icon.icon}
            />
          </a>
        );
      })}
    </div>
  );
};

export default Socials;
